import { trpc } from '@/shared/api/trpc';

// Persist the "One Supplier note" (the CRM company/contact note). Invalidates
// the per-item supplier query so the modal re-reads the saved value.
export const useUpdateSupplierNote = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateSupplierNote.useMutation({
    onSettled: () => {
      utils.operations.itemSuppliers.invalidate();
    },
  });
};
